"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _executeBound = _interopRequireDefault(require("./_executeBound.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
var _default = exports.default = (0, _restArguments.default)(function (func, context, args) {
  if (!(0, _isFunction.default)(func)) throw new TypeError('Bind must be called on a function');
  var bound = (0, _restArguments.default)(function (callArgs) {
    return (0, _executeBound.default)(func, bound, context, this, args.concat(callArgs));
  });
  return bound;
});